import { AgenteFinanceiro } from "../model/agente-financeiro.model";
import moment from "moment";
import { EntityPagedResult } from "@bndes/bndes-ux4/bndes-angular-utils";

export default class Utils {
  public static isValidJson(str: string): boolean {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  public static mesAno(valor?: string): string {
    // retorna mm/aaaa a partir de uma string com uma data em formato ISO
    return valor && (valor.substr(5,2) + '/' + valor.substr(0,4));
  }

  public static nomeAgentePorCNPJ(cnpj: string, agentesFinanceiros: AgenteFinanceiro[]) {
    const agentes = agentesFinanceiros.filter(item => item.cnpj == cnpj);
    return agentes.length > 0 ? agentes[0].nome : `agente cnpj ${cnpj} desconhecido.`;
  }

  public static dataFromISO(dataISO: string): Date {

    return moment(dataISO, 'YYYYMMDD').toDate();
  }

  public static dataCorrente(): Date {
    let d = new Date();
    //d.setMonth(4);
    //d.setFullYear(2022);
    //console.log(d);
    return d;
  }

  public static compararPorId(item1: string, item2: string): boolean {

    if (item1 && item2) {
      return item1 === item2;
    }
    if (!item1 && !item2) {
      return true;
    }
    return false;
  }
  
  public static nomeAgentePorId(id: number, agentesFinanceiros: AgenteFinanceiro[]) {
    if (!id) {
      return 'Todos os agentes';
    }
    const agentes = agentesFinanceiros.filter(item => item.id == id);
    return agentes.length > 0 ? agentes[0].nome :  `agente desconhecido (${id}).`;
  }
    
  public static nomeAgentePorCnpj(cnpj: string, agentesFinanceiros: AgenteFinanceiro[]) {
    if (!cnpj) {
      return 'Todos os agentes';
    }
    const agentes = agentesFinanceiros.filter(item => item.cnpj == cnpj);
    return agentes.length > 0 ? agentes[0].nome :  `agente desconhecido (${cnpj}).`;
  }
  
  public static ajustaCampoDate(data:any) {
    
    if (typeof data === 'string') {
      if (data.length == 10) {
        data += ' 00:00:00';
      }
      return new Date(data);
    }

    return data;
  }

  public static comparaComFuncao(a, b, atributo, funcao): number {
    if (funcao == undefined) {
      return this.compara(a, b, atributo);
    }
    if (funcao(this.fetchFromObject(a, atributo)) == funcao(this.fetchFromObject(b, atributo))) {
      return 0;
    }
    else {
      if (funcao(this.fetchFromObject(a, atributo)) > funcao(this.fetchFromObject(b, atributo))) {
        return 1;
      }
      else {
        return -1;
      }
    }
  }

  public static compara(a, b, atributo): number {
    if (this.fetchFromObject(a, atributo) == this.fetchFromObject(b, atributo)) {
      return 0;
    }
    else {
      if (this.fetchFromObject(a, atributo) > this.fetchFromObject(b, atributo)) {
        return 1;
      }
      else {
        return -1;
      }
    }
  }

  public static fetchFromObject(obj, prop) {

    if(typeof obj === 'undefined') {
      return false;
    }

    if (prop === 'self') {
      return obj;
    }

    var _index = prop.indexOf('.')
    if(_index > -1) {
        return this.fetchFromObject(obj[prop.substring(0, _index)], prop.substr(_index + 1));
    }

    return obj[prop];
  }

  public static normalizaTextoParaCsv(linha:string){
    const tam = linha?.split('')?.length || 0;
    for(let i = 0; i<tam; i++){
        linha = linha.replace(';','');
        linha = linha.replace(',','');
        linha = linha.replace('"','');
        linha = linha.replace('=','');
    }
    return linha;
  }

  public static verificaPaginaVazia(elementos: any[], atributosPaginacao: EntityPagedResult<any>, totalObjetosRetornados: number): boolean{
    
    if(elementos != undefined && elementos.length > 0) {
      atributosPaginacao.pages = Math.ceil(
            totalObjetosRetornados / atributosPaginacao.pageSize);

      if(atributosPaginacao.page > atributosPaginacao.pages) {
        return true;
      }
    }

    if(elementos != undefined && elementos.length == 0){
      return true;      
    }
    
    return false;
  }

  public static formataZerosAEsquerda(linha: string): string {
    return `="${linha}"`;
  }

  public static validaMail(mail: string): boolean {
    let mailformat = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
    if (mail.match(mailformat)) {
      return true;
    } else { 
      return false;
    }
  }

}
